/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import defaultsDeep from 'lodash/defaultsDeep';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import compose from 'lodash/fp/compose';
import { Icon } from '../../../ui/Icon';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import * as styles from './index.styles';

export const defaultData = {
  Headline: null,
  CTA: {
    value: {
      href: '',
      linktype: 'internal',
      text: '',
      url: '',
    },
  },
  Description: null,
  Item1: null,
  Item2: null,
  Item3: null,
};

const renderBenefitItem = item => {
  return (
    <li css={styles.goodForItem}>
      <span>
        <Icon customCss={styles.itemCheck} name="check" />
      </span>
      <span>
        <Text field={item} editable={false} />
      </span>
    </li>
  );
};

export class PromoCard extends SafePureComponent {
  safeRender() {
    const { props } = this;
    const fields = defaultsDeep(props.fields.fields, defaultData);
    const { t } = props;
    const { Headline, CTA, Description, Item1, Item2, Item3, Item4 } = fields;
    const showBenefits =
      !isEmpty(get(Item1, 'value')) ||
      !isEmpty(get(Item2, 'value')) ||
      !isEmpty(get(Item3, 'value')) ||
      !isEmpty(get(Item4, 'value'));
    const Url = get(CTA, 'value.href', '');
    const ctaText = get(CTA, 'value.text', '');

    const CardContainer = Url ? 'a' : 'div';
    const cardContainerProps = Url
      ? {
          href: Url,
          css: [
            styles.promoCard,
            styles.promoCardBorder,
            styles.clickablePromoCard,
          ],
        }
      : {
          css: [styles.promoCard, styles.promoCardBorder],
        };

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <CardContainer data-item="listing-promo-card" {...cardContainerProps}>
        <div>
          <div css={styles.topLine}>
            <div css={styles.headlineWrapper}>
              <h3 css={styles.headline}>
                <Text field={Headline} editable={false} />
              </h3>
            </div>
          </div>
          <div css={styles.body}>
            <Text field={Description} editable={false} />
          </div>
          {showBenefits && (
            <div>
              <div>
                <span css={styles.goodFor}>{`${t('Benefits')}`}</span>
              </div>
              <div>
                <ul>
                  {!isEmpty(get(Item1, 'value')) && renderBenefitItem(Item1)}
                  {!isEmpty(get(Item2, 'value')) && renderBenefitItem(Item2)}
                  {!isEmpty(get(Item3, 'value')) && renderBenefitItem(Item3)}
                  {!isEmpty(get(Item4, 'value')) && renderBenefitItem(Item4)}
                </ul>
              </div>
            </div>
          )}
        </div>
        {Url && (
          <div css={styles.ctaBlock}>
            <span css={styles.ctaText}>{ctaText}</span>
            <Icon customCss={styles.arrow} name="arrow-right" />
          </div>
        )}
      </CardContainer>
    );
  }
}

PromoCard.displayName = 'PromoCard';

PromoCard.defaultProps = { fields: defaultData, t: key => key };

PromoCard.propTypes = {
  fields: PropTypes.shape({
    Headline: PropTypes.shape({ value: PropTypes.string }),
    Description: PropTypes.shape({ value: PropTypes.string }),
    Url: PropTypes.string,
    ShowAsBlackCard: PropTypes.bool,
    Item1: PropTypes.shape({ value: PropTypes.string }),
    Item2: PropTypes.shape({ value: PropTypes.string }),
    Item3: PropTypes.shape({ value: PropTypes.string }),
  }),
};

export default compose(withNamespaces())(PromoCard);
